import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div<{ $clickable?: boolean }>`
  display: flex;
  flex-direction: row;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const StyledIcon = styled.div`
  width: ${({ theme }) => rem(theme.Icon.Size.Large)};
  height: ${({ theme }) => rem(theme.Icon.Size.Large)};

  &:not(:first-child) {
    margin-left: -${({ theme }) => rem(theme.Icon.Size.Large / 4)};
  }
`;

export const StyledButton = styled.a`
  border: ${({ theme }) => `${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Light}`};
  display: flex;
  min-height: ${({ theme }) => rem(theme.Icon.Size.Large)};
  min-width: ${({ theme }) => rem(theme.Icon.Size.Large)};
  border-radius: 50%;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  justify-content: center;
  align-items: center;
`;
